import type { ReactNode } from "react";
import { createContext, useMemo } from "react";

export interface PreviewModeConsumerProps {
  isPreviewMode: boolean;
}

export const PreviewModeContext = createContext<PreviewModeConsumerProps>({
  isPreviewMode: false,
});

export interface PreviewModeProps {
  isPreviewMode: boolean;
  children?: ReactNode;
}

export function PreviewMode({ isPreviewMode, children }: PreviewModeProps) {
  const context = useMemo(() => ({ isPreviewMode }), [isPreviewMode]);

  return (
    <PreviewModeContext.Provider value={context}>
      {children}
    </PreviewModeContext.Provider>
  );
}
